import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Ya corres anuncios y sientes que estás botando dinero por falta de control.', 'Quieres resultados más estables sin volverte esclavo del Ads Manager.', 'Te cuesta saber cuándo tocar una campaña y cuándo dejarla quieta.', 'No quieres un curso largo: quieres una guía rápida y directa.', 'Eres agencia, infoproductor, ecommerce, coach o tienes un negocio local y usas Meta Ads.'];
  const notFor = ['Quieres un truco mágico que reemplace tu oferta o tu producto.', 'No estás dispuesto a seguir un proceso y quieres cambiar todo cada 12 horas.', 'Buscas algo de data science o ingeniería avanzada (esto es ejecución práctica, no código).'];
  return <section className="py-20 px-4 bg-[#0a0a0f]" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-11">
          {/* Is For */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#15151e] border border-green-500/20 rounded-2xl p-8" data-id="element-12">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-13">
              <span className="text-green-500 mr-2" data-id="element-14">Esto es para ti si…</span>
            </h3>
            <ul className="space-y-4" data-id="element-15">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-16">
                  <Check className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-17" />
                  <span className="text-gray-300" data-id="element-18">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#15151e] border border-red-500/20 rounded-2xl p-8" data-id="element-19">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-20">
              <span className="text-red-500 mr-2" data-id="element-21">Esto NO es para ti si…</span>
            </h3>
            <ul className="space-y-4" data-id="element-22">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-23">
                  <X className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-gray-300" data-id="element-25">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}